module.exports = __webpack_public_path__ + "media/images/DeLaChakraALaMesa-393d7bc18a818307756a1de7de2b56db.jpg";